import cn from "classnames";
import BookIndex from "components/shared/book/list";
import SharedReactTable from "components/shared/reactTable";
import { paths } from "helpers/paths";
import { rowIndexColumn, SelectColumnFilter } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import React from "react";
import { Link } from "react-router-dom";
import { list } from "sources/books/transportColumns";
import { numbersList } from "sources/books/trucks";
import { removeAllCars, removeCars } from "sources/books/usersGroups";
import AddAllCarsToGroup from "./addAllCarsToGroup";
import AddCarToGroup from "./addCarToGroup";

class UsersGroupCars extends BookIndex {
    state = { selectedItems: [], tableColumns: this.tableColumns };

    get tableColumns() {
        return [
            {
                Header: () => {
                    const allItemsSelected = this.state.selectedItems.length === this.props.items.length;
                    return (
                        <div className="d-flex justify-content-center pt-1">
                            <span
                                className={cn("checkbox", { "checkbox--checked": allItemsSelected })}
                                onClick={() =>
                                    allItemsSelected
                                        ? this.setState({ selectedItems: [] })
                                        : this.setState({ selectedItems: this.props.items })
                                }
                            />
                        </div>
                    );
                },
                accessor: "checkbox",
                width: 30,
                sortable: false,
                Cell: ({ row: { original } }) => {
                    const itemSelected = this.state.selectedItems.some((item) => item.carId === original.carId);
                    return (
                        <div className="d-flex justify-content-center pt-1">
                            <span
                                className={cn("checkbox", { "checkbox--checked": itemSelected })}
                                onClick={() =>
                                    itemSelected
                                        ? this.setState({
                                              selectedItems: this.state.selectedItems.filter(
                                                  (item) => item.carId !== original.carId,
                                              ),
                                          })
                                        : this.setState({ selectedItems: this.state.selectedItems.concat(original) })
                                }
                            />
                        </div>
                    );
                },
            },
            rowIndexColumn,
            {
                Header: "Номер",
                accessor: "carNumber",
                filterable: true,
                Cell: ({
                    value,
                    row: {
                        original: { carId },
                    },
                }) => (
                    <Link target="_blank" to={paths.trucksShow(carId)}>
                        {value}
                    </Link>
                ),
                id: "carId",
                filterType: "select",
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{ url: numbersList, inputProps: { name: "carId" }, propName: "number" }}
                    />
                ),
            },
            {
                Header: "Транспортная колонна",
                accessor: "transportColumnName",
                filterable: true,
                Cell: ({
                    value,
                    row: {
                        original: { transportColumnId },
                    },
                }) => (
                    <Link target="_blank" to={paths.transportColumnsShow(transportColumnId)}>
                        {value}
                    </Link>
                ),
                id: "transportColumnId",
                filterType: "select",
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{ url: list, inputProps: { name: "transportColumnId" }, propName: "name" }}
                    />
                ),
            },
            {
                Header: "",
                accessor: "actions",
                sortable: false,
                notExportable: true,
                width: 100,
                Cell: ({ row }) => {
                    const deleteAction = () =>
                        this.props.modal({
                            name: "confirm",
                            title: "Удаление машины",
                            text: "Вы уверены, что хотите удалить машину из группы?",
                            buttons: { confirm: "Удалить", cancel: "Отменить" },
                            action: () =>
                                removeCars({
                                    groupId: this.props.match.params.groupId,
                                    carIds: [row.original.carId],
                                }).then(() => this.props.mergeParams({})),
                        });
                    return (
                        <div className="btn btn-xs btn-outline-danger" onClick={deleteAction}>
                            Удалить
                        </div>
                    );
                },
            },
        ];
    }

    componentWillUnmount() {
        this.props.clearParams();
    }

    renderCreateButton = () => {
        const { modal, mergeParams, match } = this.props;
        const addCarAction = () =>
            modal({
                name: "default",
                windowMod: "wide",
                title: "Добавление машин",
                CustomBody: AddCarToGroup,
                bodyData: { mergeParams, groupId: match.params.groupId },
            });
        const addAllCarsAction = () => {
            modal({
                name: "default",
                title: "Добавление машин",
                CustomBody: AddAllCarsToGroup,
                bodyData: { mergeParams, groupId: match.params.groupId },
            });
        };
        const deleteAllCarsAction = () =>
            modal({
                name: "confirm",
                title: "Удаление машин",
                text: "Вы уверены, что хотите удалить все машины из группы?",
                buttons: { confirm: "Удалить", cancel: "Отменить" },
                action: () =>
                    removeAllCars({ groupId: this.props.match.params.groupId }).then(() => this.props.mergeParams({})),
            });
        const deleteSelectedCarsAction = () =>
            modal({
                name: "confirm",
                title: "Удаление выбранных машин",
                text: "Вы уверены, что хотите удалить выбранные машины из группы?",
                buttons: { confirm: "Удалить", cancel: "Отменить" },
                action: () =>
                    removeCars({
                        groupId: this.props.match.params.groupId,
                        carIds: this.state.selectedItems.map((item) => item.carId),
                    }).then(() => this.props.mergeParams({})),
            });

        return (
            <>
                <div className="btn btn-brand btn-xs mr-2" onClick={addCarAction}>
                    Добавить машины
                </div>
                <div className="btn btn-brand btn-xs mr-2" onClick={addAllCarsAction}>
                    Добавить все машины
                </div>
                {this.state.selectedItems.length > 0 && (
                    <div className="btn btn-outline-danger btn-xs mr-2" onClick={deleteSelectedCarsAction}>
                        Удалить выбранные машины
                    </div>
                )}
                <div className="btn btn-danger btn-xs" onClick={deleteAllCarsAction}>
                    Удалить все машины
                </div>
            </>
        );
    };

    render() {
        const { getList, ...props } = this.props;

        return (
            <div className="container-fluid h-100 pb-3">
                <div className="card card-body h-100">
                    <div className="d-flex flex-column h-100">
                        <div className="d-flex justify-content-end pb-3">{this.renderCreateButton()}</div>
                        <div className="flex-grow-1 overflow-hidden">
                            <SharedReactTable
                                {...props}
                                wrapCname="h-100"
                                getList={(params) =>
                                    getList({ ...params, groupId: parseInt(props.match.params.groupId) })
                                }
                                columns={this.state.tableColumns}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default tableContainer(UsersGroupCars, "users-group-cars");
